export const BULK_PRODUCTS_QUERY_PARAM = "bulk";

export const PRESELECTED_TEETH_QUERY_PARAM = "teeth";

const buildBulkSearch = (bulkProductIds?: ReadonlyArray<string>): string =>
  bulkProductIds?.length
    ? `?${BULK_PRODUCTS_QUERY_PARAM}=${bulkProductIds.join(",")}`
    : "";

export const splitBulkProductIds = (value: string | null): string[] =>
  value ? value.split(",").filter(Boolean) : [];

export const parseBulkProductIds = (search: string): string[] =>
  splitBulkProductIds(
    new URLSearchParams(search).get(BULK_PRODUCTS_QUERY_PARAM)
  );

export const parsePreselectedTeeth = (search: string): number[] => {
  const value = new URLSearchParams(search).get(PRESELECTED_TEETH_QUERY_PARAM);

  return value
    ? value
        .split(",")
        .map(tooth => Number(tooth))
        .filter(tooth => Number.isInteger(tooth) && tooth > 0)
    : [];
};

export const buildPreselectedTeethSearch = (
  preselectedTeeth?: ReadonlyArray<number>
): string =>
  preselectedTeeth?.length
    ? `?${PRESELECTED_TEETH_QUERY_PARAM}=${preselectedTeeth.join(",")}`
    : "";

export const buildProductPath = (
  orderId: string,
  productId: string,
  bulkProductIds?: ReadonlyArray<string>
): string =>
  `/orders/${orderId}/configure/products/${productId}${buildBulkSearch(
    bulkProductIds
  )}`;

export const buildProductStepPath = (
  orderId: string,
  productId: string,
  stepKey: string,
  bulkProductIds?: ReadonlyArray<string>
): string =>
  `/orders/${orderId}/configure/products/${productId}/${stepKey}${buildBulkSearch(
    bulkProductIds
  )}`;

export const buildAddProductPath = (orderId: string): string =>
  `/orders/${orderId}/configure/products/add`;

export const buildOrderInfoPath = (orderId: string): string =>
  `/orders/${orderId}/configure/order-info`;

export const buildOrderSummaryPath = (orderId: string): string =>
  `/orders/${orderId}/configure/summary`;

export const buildOrderConfirmationPath = (orderId: string): string =>
  `/orders/${orderId}/configure/confirmation`;
